module.exports = __webpack_public_path__ + "static/groper-495fd0b25ac67b592ebefe1e4802f9a6.png";